import {
  Dic
} from '@src/common/utils'
import i18n from '@src/common/lib/i18n'
import utils from '@src/common/utils'
const personOption = function (isVisitor) {
  return {
    add: '新增',
    edit: '修改',
    view: '查看',
    page: true,
    selection: false,
    index: false,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewFormSlot: true,
    labelSuffix: '：',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '140px',
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 200,
    dialogWidth: '450px',
    emptyText: '暂无数据',
    column: [{
      label: '',
      prop: 'personnelCode',
      align: 'right',
      search: false,
      addDisplay: false,
      editDisplay: false,
      editDisabled: false,
      viewDisplay: false,
      overHidden: true,
      formslot: true,
      columnWidth: 50,
    }, {
      label: '姓名',
      prop: 'name',
      addDisplay: false,
      editDisplay: false,
      // viewDisplay: false,
      overHidden: true,
      search: true,
      searchPlaceholder: '请输入姓名',
      span: 12,
    },
    {
      label: '工号',
      prop: 'workNo',
      hide: isVisitor,
      search: !isVisitor,
      searchPlaceholder: '请输入工号',
      span: 12,
    },
    {
      label: '部门',
      prop: 'departmentName',
      search: false,
      hide:isVisitor,
      // searchPlaceholder: '请输入部门',
      span: 12,
    },
    {
      label: '岗位',
      prop: 'position',
      hide: isVisitor,
      search: false,
      span: 12,
    },
    {
      label: '是否在职',
      prop: 'status',
      type: 'select',
      search: false,
      hide: isVisitor,
      span: 12,
      dicData: [{
        label: '全部',
        value: -1,
      },
      {
        label: '已激活',
        value: 1,
      },
      {
        label: '已禁用',
        value: 2,
      },
      {
        label: '未激活',
        value: 4,
      },
      ],
      formatter: function (row, value) {
        let str = ''
        if (value == -1) {
          str = '全部'
        }
        if (value == 1) {
          str = '已激活'
        }
        if (value == 2) {
          str = '已禁用'
        }
        if (value == 4) {
          str = '未激活'
        }
        return str
        // return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
      },
    },
    {
      label: '电话',
      // align: 'center',
      prop: 'phone',
      search: false,
      searchPlaceholder: '请输入电话',
      span: 12,
    },
    ]
  }
}
export default personOption